<button class="button-accent view-order-button"
  [attr.aria-hidden]="modalService.isModalOpen()"
  [tabindex]="modalService.isModalOpen() ? -1 : 0"
  [ngClass]="{'full-width': fullWidth()}">
  <span class="sr-only">{{'View order'}}</span>
  <div class="grocery-icon-container">
    <cwo-icon class="icon" [name]="iconNameType.grocery" />
    @if (layout.state().viewport === 'mobile') {
      <span class="view-order-text">{{'shared_components.view_order_button.view_order' | transloco}}</span>
    }
  </div>

  @if (layout.state().viewport !== 'mobile' && !fullWidth()) {
    <div class="center-divider divider"></div>
  }

  <div class="cart-number-container">
    @if (layout.state().viewport === 'mobile' || fullWidth()) {
      <div class="divider"></div>
    }

    <span class="label">{{itemCount()}}</span>
  </div>
</button>
